package com.neurobs.js.dom

import com.neurobs.js.view._
import org.scalajs.dom.raw.HTMLElement
import scalatags.JsDom.all._

/** ModalView that uses divs with CSS to cover everything in the window */
class ModalViewDiv extends ModalView {
	private val modalDiv: HTMLElement = div().render
	private var current: Container = null

	/** The element to which GUI elements should be added */
	val clientElement: HTMLElement = div().render

	/** The main element that should be added to the document */
	val element: HTMLElement = div(clientElement, modalDiv).render

	/** Class name assumed to be in the CSS for the page. Example:
	  *
	  * .modal-background {
	  * 	display: block;
	  * 	position: fixed;
	  * 	z-index: 1;
	  * 	left: 0;
	  * 	top: 0;
	  * 	width: 100%;
	  * 	height: 100%;
	  * 	overflow: auto;
	  * 	background-color: rgb(0,0,0);
	  * 	background-color: rgba(0,0,0,0.4);
	  * 	text-align: center;
	  * }
	  */
	val modalBackgroundClass = "modal-background"

	/** Class name assumed to be in the CSS for the page. Example:
	  *
	  * .modal-window {
	  *	background-color: #fefefe;
	  *	margin: 15% auto;
	  *	padding: 20px;
	  *	border: 1px solid #888;
	  *	display: inline-block;
	  *	border-radius: 6px;
	  * }
	  */
	val modalWindowClass = "modal-window"

	override def show(contents: Container): Unit = {
		contents match {
			case ElementContainer(e) =>
				modalDiv.innerHTML = ""
				modalDiv.appendChild(
					div(`class`:=modalBackgroundClass)(
						div(`class`:=modalWindowClass)(
							e
						)
					).render
				)
				current = contents
			case _ => throw new Exception("ModalViewDiv.showModal contents invalid type")
		}
	}

	override def dismiss(contents: Container): Unit = {
		if (current == contents) {
			modalDiv.innerHTML = ""
			current = null
		}
	}

	override def forceDismiss(): Unit = {
		modalDiv.innerHTML = ""
	}
}
